export default __webpack_public_path__ + "static/media/briyani-chicken.d0e4d2f8.png";